import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

export const VerticalDivider = () => {
  return <ChakraV3.Box h={7} w='1px' bg='gray.200' />;
};
